export default [{
  path: '/ParticipationTicket',//票证办理程序
  name: 'TicketPage',
  meta: {
    title:'票证办理程序_参会指南_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Participation/Ticket.vue')
},{
  path: '/ParticipationReporter',//记者参会指南
  name: 'ReporterPage',
  meta: {
    title:'记者参会指南_参会指南_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Participation/Reporter.vue')
},{
  path: '/ParticipationPdf',//邀请函
  name: 'PdfPPage',
  meta: {
    title:'邀请函_参会指南_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Participation/pdfPage.vue')
},{
  path: '/ParticipationAnswer',//参会问答
  name: 'answerPage',
  meta: {
    title:'参会问答_参会指南_中国国际投资贸易洽谈会',
  },
  component: () => import('@/view/Participation/answer.vue')
}]




// WEBPACK FOOTER //
// ./src/router/Participation.js